import VideoBox from 'component/VideoBox'

import { Wrapper } from './Styled'
import { memo } from 'react'

interface Template5Props {
  videoData?: any[]
}

/**
 * 模板 ID: "5": 左右滑動(小圖)
 * */
function Template5({ videoData }: Template5Props) {
  return (
    // 因這裡有滑動事件, 設定.swiper-no-swiping 禁止CMS View的左右滑動切換頻道功能
    <Wrapper className={'swiper-no-swiping'}>
      {videoData?.map((item, i) => {
        return <VideoBox key={i} videoInfo={item} allowUnload />
      })}
    </Wrapper>
  )
}

export default memo(Template5)
